document.addEventListener('DOMContentLoaded', () => {
    const stickyATC = document.querySelector('#md-sticky-atc');
    const productSection = document.querySelector('.product');
    const img = stickyATC.querySelector('.product-content img');
    const btn = stickyATC.querySelector('[name="add"]');
    const selectField = stickyATC.querySelector('select[name="id"]');

    const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        stickyATC.classList.remove('show');
        document.documentElement.style.paddingBottom = '0';
        } else {
        stickyATC.classList.add('show');
        document.documentElement.style.paddingBottom = `${stickyATC.clientHeight}px`;
        document.documentElement.style.height = 'auto';
        }
    });
    }, {
    root: null,
    threshold: 0
    });

    if (productSection) {
    observer.observe(productSection);
    }

    if (selectField) {
        selectField.addEventListener('change', () => {
            // img.setAttribute('src', selectField.options[selectField.selectedIndex].dataset.img);
            const selectedOption = selectField.options[selectField.selectedIndex];

            // Update image
            img.setAttribute('src', selectedOption.dataset.img);

            // Get prices from data attributes
            const price = selectedOption.dataset.price;
            const comparePrice = selectedOption.dataset.comparePrice;

            // Update DOM
            const sellingPriceEl = document.querySelector('.selling_price');
            const comparePriceEl = document.querySelector('.compare_at_price');

            if (sellingPriceEl) {
                sellingPriceEl.textContent = price;
            }

            if (comparePriceEl) {
                comparePriceEl.textContent = comparePrice;
            }
        });
    }

    document.querySelector('.product-form [name="id"]')?.addEventListener('change', (e) => {
    const value = Number(e.target.value);
    if (value) {
        selectField.value = value;
    }
    });
});
